import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../api/api";
import { fetchActiveCounts } from "../api/articlesApi";
import CategoryBarChart from "./CategoryBarChart";
import Loader from "./Loader";
import "../styles/Home.css";

export default function Home() {
  const [counts, setCounts] = useState({});
  const [totalActive, setTotalActive] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchActiveCounts()
      .then((res) => {
        if (cancelled) return;
        setCounts(res.categoryCounts);
        setTotalActive(res.totalActive);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err?.response?.data?.message ||
              err.message ||
              "Failed to load active post counts."
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const topCategory = CATEGORIES.map((cat) => ({
    ...cat,
    count: counts[cat.label] ?? 0,
  })).sort((a, b) => b.count - a.count)[0];

  return (
    <div className="home">
      <div className="home-hero">
        <span className="home-eyebrow">Today Talks Admin</span>
        <h2 className="home-heading">Choose a category to get started</h2>
        <p className="home-subheading">
          Manage posts, statuses, and trending flags for each section of the site.
        </p>
      </div>

      <div className="home-stats">
        <div className="home-stat-card">
          <span className="home-stat-label">Total active posts</span>
          <span className="home-stat-value">
            {loading ? "—" : totalActive}
          </span>
        </div>
        <div className="home-stat-card">
          <span className="home-stat-label">Categories tracked</span>
          <span className="home-stat-value">{CATEGORIES.length}</span>
        </div>
        <div className="home-stat-card home-stat-card-accent">
          <span className="home-stat-label">Top category</span>
          <span className="home-stat-value home-stat-value-sm">
            {loading || !topCategory
              ? "—"
              : `${topCategory.label} (${topCategory.count})`}
          </span>
        </div>
      </div>

      <div className="home-panel">
        <div className="home-panel-header">
          <h3 className="home-panel-title">Active posts by category</h3>
          <p className="home-panel-subtitle">
            Click any row to jump straight to that category.
          </p>
        </div>

        {loading && <Loader label="Loading post counts..." />}
        {!loading && error && <p className="home-panel-error">{error}</p>}
        {!loading && !error && (
          <CategoryBarChart categories={CATEGORIES} counts={counts} />
        )}
      </div>

      <div className="home-grid">
        {CATEGORIES.map((cat) => (
          <Link key={cat.key} to={`/category/${cat.key}`} className="home-card">
            <span className="home-card-icon">{cat.icon}</span>
            <span className="home-card-label">{cat.label}</span>
            <span className="home-card-arrow">→</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
